import {
    CHANGE_BET_SLIP_MODAL_SELECTED_SCREEN,
    COLLAPSE_OPEN_BET_ACCORDION,
    COLLAPSE_SETTLED_BET_ACCORDION,
    OPEN_CLOSE_BET_SLIP_MODAL
} from '../../../constants/actionTypes';
import {SET_BET_SLIP_CONTAINER_HEIGHT, TOGGLE_FILTER_WINS_SETTLED_BETS} from "../constants/actionTypes";
import {OPEN_BETS, PLACED_BETS, SETTLED_BETS} from '../../../constants/identifiers';
import defaultStoreValues from '../../../constants/defaultStoreValues';
import {COLLAPSE_PLACED_BET_ACCORDION} from './../../../constants/actionTypes';


export default (state, action) => {
    let collapsedOpenBetAccordions = state.collapsedOpenBetAccordions.slice();
    let collapsedPlacedBetAccordions = state.collapsedPlacedBetAccordions.slice();
    let collapsedSettledBetAccordions = state.collapsedSettledBetAccordions.slice();

    switch (action.type) {
        case OPEN_CLOSE_BET_SLIP_MODAL:
            let newIsBetSlipModalOpen = !state.isBetSlipModalOpen;
            let newSelectedBetSlipScreen = state.selectedBetSlipScreen;

            if (newIsBetSlipModalOpen) {
                newSelectedBetSlipScreen = state.openBetsList.length > 0
                    ? OPEN_BETS
                    : state.placedBets.length > 0
                        ? PLACED_BETS
                        : state.settledBets.length > 0
                            ? SETTLED_BETS
                            : OPEN_BETS;
            }

            return {
                ...state,
                isBetSlipModalOpen: newIsBetSlipModalOpen,
                selectedBetSlipScreen: newSelectedBetSlipScreen,
                isBetHistoryOpen: defaultStoreValues.isBetHistoryOpen,
                filterWinsSettledBets: defaultStoreValues.filterWinsSettledBets
            };
        case CHANGE_BET_SLIP_MODAL_SELECTED_SCREEN:
            return {
                ...state,
                selectedBetSlipScreen: action.option
            };

        case TOGGLE_FILTER_WINS_SETTLED_BETS:
            return {
                ...state,
                filterWinsSettledBets: !state.filterWinsSettledBets
            };
        case COLLAPSE_OPEN_BET_ACCORDION:
            let newCollapsedOpenBetAccordions;
            if (collapsedOpenBetAccordions.find((gameCategory) => gameCategory === action.gameCategory)) {
                newCollapsedOpenBetAccordions = collapsedOpenBetAccordions.filter((gameCategory) => gameCategory !== action.gameCategory);
            } else {
                collapsedOpenBetAccordions.push(action.gameCategory);
                newCollapsedOpenBetAccordions = collapsedOpenBetAccordions;
            }
            return {
                ...state,
                collapsedOpenBetAccordions: newCollapsedOpenBetAccordions,
            };
        case COLLAPSE_PLACED_BET_ACCORDION:
            let newCollapsedPlacedBetAccordions;
            if (collapsedPlacedBetAccordions.find((gameCategory) => gameCategory === action.gameCategory)) {
                newCollapsedPlacedBetAccordions = collapsedPlacedBetAccordions.filter((gameCategory) => gameCategory !== action.gameCategory);
            } else {
                collapsedPlacedBetAccordions.push(action.gameCategory);
                newCollapsedPlacedBetAccordions = collapsedPlacedBetAccordions
            }
            return {
                ...state,
                collapsedPlacedBetAccordions: newCollapsedPlacedBetAccordions,
            };
        case COLLAPSE_SETTLED_BET_ACCORDION:
            let newCollapsedSettledBetAccordions;
            if (collapsedSettledBetAccordions.find((gameCategory) => gameCategory === action.gameCategory)) {
                newCollapsedSettledBetAccordions = collapsedSettledBetAccordions.filter((gameCategory) => gameCategory !== action.gameCategory);
            } else {
                collapsedSettledBetAccordions.push(action.gameCategory);
                newCollapsedSettledBetAccordions = collapsedSettledBetAccordions
            }
            return {
                ...state,
                collapsedSettledBetAccordions: newCollapsedSettledBetAccordions,
            };
        case SET_BET_SLIP_CONTAINER_HEIGHT:
            return {
                ...state,
                betSlipModalContainerHeight: action.height,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/reducers/betSlipReducer.js